<div class="card">
  <div class="card-header">{{ title }}</div>
  <div class="card-body" [innerHTML]="messaggio"></div>
  <div class="card-footer">
    <button nbButton status="disabled" class="btn btn-danger" (click)="dismiss()">NO</button>
    <button nbButton status="primary" style="cursor:pointer; float: right;" class="btn btn-success" (click)="confirm()">SI</button>
  </div>
<div class="card">